import apiRepeatOrder from '@/api/vo/repeatOrder';

const defaultState = () => ({
	listHistoryRO: [],
	historyROPagination: '',
	listHistoryROSponsor: [],
	historyROSponsorPagination: '',
	listGroupOmset: [],
	groupOmsetPagination: '',
	summaryPersonal: '',
	detailGroupOmset: [],
	detailGroupOmsetPagination: '',
	responSuksesRO: {},
	responSuksesUpgrade: {},
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setHistoryRO(state, data) {
		state.listHistoryRO = data.data
		state.historyROPagination = data.pagination
	},
	setGroupOmset(state, data) {
		state.listGroupOmset = data.data
		state.groupOmsetPagination = data.pagination
		state.summaryPersonal = data.summary
	},
	setDetailGroupOmset(state, data) {
		state.detailGroupOmset = data.data
		state.detailGroupOmsetPagination = data.pagination
	},
	saveResponseError(state, data) {
		state.responseError = data;
	},
	setSuksesRO(state, data) {
		state.responSuksesRO = data
	},
	setSuksesUpgrade(state, data) {
		state.responSuksesUpgrade = data
	},
};

const actions = {

	getHistoryRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRepeatOrder.getHistoryRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRO', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRO', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getGroupOmset({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRepeatOrder.getGroupOmset(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setGroupOmset', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setGroupOmset', { data: [], pagination: {} });
				reject()
			});
		});
		// commit('setGroupOmset', { data: results.data, pagination: results.pagination, summary: results.summary_personal  });
	},

	getDetailGroupOmset({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRepeatOrder.getDetailGroupOmset(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailGroupOmset', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailGroupOmset', { data: [], pagination: {} });
				reject()
			});
		});
	},

	inputRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRepeatOrder.inputRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSuksesRO', data.results);
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch((err) => {
				const data = err.response.data.data
				commit("saveConfirmResponse", data);
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, repeat order tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	inputUpgrade({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiRepeatOrder.inputUpgrade(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setSuksesUpgrade', data.results);
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch((err) => {
				const data = err.response.data.data
				commit("saveConfirmResponse", data);
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, upgrade kemitraan tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};